import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import { PropsWithChildren } from 'react';

import { CONFIG } from '~src/config/config';

posthog.init(CONFIG.POSTHOG_API_KEY, {
  api_host: 'https://eu.i.posthog.com',
  /**
   * Disabled because ./src/components/PageviewTracker.tsx
   * is in charge of capturing pageviews
   */
  capture_pageview: false,
  /**
   * Opt back in because disabling $pageview capture disables $pageleave events
   */
  capture_pageleave: true,
});

export function TrackingProvider({ children }: PropsWithChildren) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
